import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import axios from 'axios';
import fileDownload from 'js-file-download';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import _ from 'lodash';
import { reportSchema, reportListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/reports/actions';
import { ReportsActionTypes as types } from 'app/ducks/reports/types';

function* createPayoutSummaryReportSaga(action): any {
  yield put(sagaActions.createPayoutSummaryReportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).reports.createPayoutSummary(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, reportSchema);
    const report = normalizedResponse.entities.reports[normalizedResponse.result];
    axios
      .get(report.reportUrl, {
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        },
      })
      .then((res) => {
        fileDownload(res.data, report.fileName);
      });

    yield put(sagaActions.createPayoutSummaryReportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPayoutSummaryReportFailed(
          _.isEmpty(error) ? {} : error?.response?.data?.errors,
        ),
      ),
    );
  }
}

function* createPayoutDetailedReportSaga(action): any {
  yield put(sagaActions.createPayoutDetailedReportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).reports.createPayoutDetailed(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, reportSchema);
    const report = normalizedResponse.entities.reports[normalizedResponse.result];
    axios
      .get(report.reportUrl, {
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        },
      })
      .then((res) => {
        fileDownload(res.data, report.fileName);
      });

    yield put(
      sagaActions.createPayoutDetailedReportSuccess(normalizedResponse),
    );
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPayoutDetailedReportFailed(
          _.isEmpty(error) ? {} : error?.response?.data?.errors,
        ),
      ),
    );
  }
}

function* createRefundDetailedReportSaga(action): any {
  yield put(sagaActions.createRefundDetailedReportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).reports.createRefundDetailed(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, reportSchema);
    const report = normalizedResponse.entities.reports[normalizedResponse.result];
    axios
      .get(report.reportUrl, {
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        },
      })
      .then((res) => {
        fileDownload(res.data, report.fileName);
      });

    yield put(
      sagaActions.createRefundDetailedReportSuccess(normalizedResponse),
    );
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createRefundDetailedReportFailed(
          _.isEmpty(error) ? {} : error?.response?.data?.errors,
        ),
      ),
    );
  }
}

function* createBankDebitDetailedReportSaga(action): any {
  yield put(sagaActions.createBankDebitDetailedReportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).reports.createBankDebitDetailed(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, reportSchema);
    const report = normalizedResponse.entities.reports[normalizedResponse.result];
    axios
      .get(report.reportUrl, {
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        },
      })
      .then((res) => {
        fileDownload(res.data, report.fileName);
      });

    yield put(
      sagaActions.createBankDebitDetailedReportSuccess(normalizedResponse),
    );
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createBankDebitDetailedReportFailed(
          _.isEmpty(error) ? {} : error?.response?.data?.errors,
        ),
      ),
    );
  }
}
function* createMatchPaymentsGridReportSaga(action): any {
  yield put(sagaActions.createMatchPaymentsGridReportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).reports.createMatchPaymentsGrid(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, reportSchema);
    const report = normalizedResponse.entities.reports[normalizedResponse.result];
    axios
      .get(report.reportUrl, {
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        },
      })
      .then((res) => {
        fileDownload(res.data, report.fileName);
      });

    yield put(
      sagaActions.createMatchPaymentsGridReportSuccess(normalizedResponse),
    );
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createMatchPaymentsGridReportFailed(
          _.isEmpty(error) ? {} : error?.response?.data?.errors,
        ),
      ),
    );
  }
}

function* createTeamConnectionsReportSaga(action): any {
  yield put(sagaActions.createTeamConnectionsReportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).reports.createTeamConnections(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, reportSchema);
    const report = normalizedResponse.entities.reports[normalizedResponse.result];
    axios
      .get(report.reportUrl, {
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        },
      })
      .then((res) => {
        fileDownload(res.data, report.fileName);
      });

    yield put(
      sagaActions.createTeamConnectionsReportSuccess(normalizedResponse),
    );
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createTeamConnectionsReportFailed(
          _.isEmpty(error) ? {} : error?.response?.data?.errors,
        ),
      ),
    );
  }
}

function* createOverdueMatchPaymentsReportSaga(action): any {
  yield put(
    sagaActions.createOverdueMatchPaymentsReportPending(action.payload),
  );
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).reports.createOverdueMatchPayments(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, reportSchema);
    const report = normalizedResponse.entities.reports[normalizedResponse.result];
    axios
      .get(report.reportUrl, {
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        },
      })
      .then((res) => {
        fileDownload(res.data, report.fileName);
      });

    yield put(
      sagaActions.createOverdueMatchPaymentsReportSuccess(normalizedResponse),
    );
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createOverdueMatchPaymentsReportFailed(
          _.isEmpty(error) ? {} : error?.response?.data?.errors,
        ),
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPayoutSummaryReportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_PAYOUT_SUMMARY_REPORT_REQUESTED,
    createPayoutSummaryReportSaga,
  );
}

function* createPayoutDetailedReportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_PAYOUT_DETAILED_REPORT_REQUESTED,
    createPayoutDetailedReportSaga,
  );
}
function* createRefundDetailedReportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_REFUND_DETAILED_REPORT_REQUESTED,
    createRefundDetailedReportSaga,
  );
}
function* createBankDebitDetailedReportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_BANK_DEBIT_DETAILED_REPORT_REQUESTED,
    createBankDebitDetailedReportSaga,
  );
}
function* createMatchPaymentsGridReportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_MATCH_PAYMENTS_GRID_REPORT_REQUESTED,
    createMatchPaymentsGridReportSaga,
  );
}
function* createTeamConnectionsReportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_TEAM_CONNECTIONS_REPORT_REQUESTED,
    createTeamConnectionsReportSaga,
  );
}
function* createOverdueMatchPaymentsReportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_REQUESTED,
    createOverdueMatchPaymentsReportSaga,
  );
}

export default function* root(): any {
  yield all([
    createPayoutSummaryReportSagaWatcher(),
    createPayoutDetailedReportSagaWatcher(),
    createRefundDetailedReportSagaWatcher(),
    createBankDebitDetailedReportSagaWatcher(),
    createMatchPaymentsGridReportSagaWatcher(),
    createTeamConnectionsReportSagaWatcher(),
    createOverdueMatchPaymentsReportSagaWatcher(),
  ]);
}
